import api from '@/helpers/api'
import Page from "../pages/model";
import { assign, each, get, map } from 'lodash'
import { STATUS_APPROVED, STATUS_DECLINED, STATUS_IN_REVIEW } from './model'
import { NULL_UID } from '../../../constants'
import { STUDENT } from '../roles/model'


export default {
    state: {

    },

    mutations: {

    },

    getters: {
        applicationIndex (state, getters) {
            return getters.query().with(['user', 'organization']).get()
        },

        applicationById (state, getters) {
            return (itemId) => {
                return getters.query().with([
                    'user.roles.role',
                    'user.roles.organization',
                    'user.roles.group',
                    'user.roles.position',
                    'organization.parent.parent'
                ]).find(itemId)
            }
        }
    },

    actions: {
        create (store, application) {
            Page.dispatch('addLoader', 'applications.create')
            let post = assign({comments: '.'}, application)
            return api.post('/api/v1/applications', post)
            .then(res => {
                store.dispatch('insertOrUpdate', { data: res.data.data })
                return res.data.data
            }).finally(()=>{
                Page.dispatch('removeLoader', 'applications.create')
            })
        },
        remove (store, id) {
            Page.dispatch('addLoader', 'applications.remove')

            return api.delete('/api/v1/applications/Delete', {params: {id}})
            .then(res => {
                store.dispatch('delete', res.data.data.id)
                return res.data.data
            }).finally(()=>{
                Page.dispatch('removeLoader', 'applications.remove')
            })
        },
        update (store,  params) {
            Page.dispatch('addLoader', 'applications.update')

            return api.post('/api/v1/applications/Update', params)
            .then(res => {
                store.dispatch('insertOrUpdate', { data: res.data.data })

                return res.data.data
            }).finally(()=>{
                Page.dispatch('removeLoader', 'applications.update')
            })
        },
        save (store, data) {
            Page.dispatch('addLoader', 'applications.save')
            return store.dispatch(data.id ? 'update' : 'create', data).finally(()=>{
                Page.dispatch('removeLoader', 'applications.save')
            })
        },
        approve(store,  application) {
            Page.dispatch('addLoader', 'applications.approve')
            let post = assign({}, application, {status: STATUS_APPROVED, comments: '.'})

            return store.dispatch('update', post)
                .then(res => {
                    return res
                }).finally(()=>{
                    Page.dispatch('removeLoader', 'applications.approve')
                })
        },
        decline(store,  application) {
            Page.dispatch('addLoader', 'applications.decline')
            let post = assign({}, {status: STATUS_DECLINED}, application)
            return store.dispatch('update', post)
            .then(res => {
                return res
            }).finally(()=>{
                Page.dispatch('removeLoader', 'applications.decline')
            })
        },
        fetchById(store, ticketId) {
            Page.dispatch('addLoader', 'applications.fetchById')

            return api.get(`/api/v1/applications/${ticketId}`)
                .then(res => {
                    store.dispatch('insertOrUpdate', { data: res.data.data })
                    return res.data
                }).finally(()=>{
                    Page.dispatch('removeLoader', 'applications.fetchById')
                })
        },
        fetchItems (store, params) {
            Page.dispatch('addLoader', 'applications.fetchItems')

            return api.get('/api/v1/applications', {params: assign({}, params)})
                .then(res => {
                    store.dispatch('insertOrUpdate', { data: res.data.data })
                    return res.data
                }).finally(()=>{
                    Page.dispatch('removeLoader', 'applications.fetchItems')
                })
        },
        fetchMyApplications (store, params) {
            Page.dispatch('addLoader', 'applications.fetchItems')

            return api.get('/api/v1/applications', {params: assign({}, params), headers: {
                'organizationid': NULL_UID
                }})
            .then(res => {
                store.dispatch('insertOrUpdate', { data: res.data.data })
                return res.data
            }).finally(()=>{
                Page.dispatch('removeLoader', 'applications.fetchItems')
            })
        },

        updateGroup (store, {userId, groupId, organizationId}) {
            Page.dispatch('addLoader', 'applications.updateGroup')

            return store.dispatch('fetchItems', {userId})
            .then((data) => {
                let applications = store.getters.findIn(map(get(data, 'data', []), 'id'))
                let promises = []
                each(applications, application => {
                    each(get(application, 'userRolePivot', []), userRole => {
                        if (organizationId && get(userRole, 'organization.id') === organizationId) {
                            if (groupId !== NULL_UID) {
                                userRole.group = {id: groupId}
                            } else {
                                delete userRole.group
                            }
                        }
                    })

                    promises.push(store.dispatch('save', application))
                })

                return Promise.all(promises)
            })
            .finally(()=>{
                Page.dispatch('removeLoader', 'applications.updateGroup')
            })
        },
    }
}
